import { PublicKey } from "@solana/web3.js";

export const STAKE_PROGRAM_ID = new PublicKey(
  "Stake11111111111111111111111111111111111111"
);

export const MNDE_REALM_PUBKEY = new PublicKey(
  "899YG3yk4F66ZgbNWLHriZHTXSKk9e1kvsKEquW7L6Mo"
);

export const MSOL_ADDRESS = new PublicKey(
  "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So"
);

export const MARINADE_REFERRAL = new PublicKey(
  "MariuAU5bpAbmyX21J2igSHTRF3Ah4GyERRfDBwrPYo"
);

export const MARINADE_PROGRAM_ID = new PublicKey(
  "MarBmsSgKXdrN1egZf5sqe1TMai9K1rChYNDJgjq7aD"
);

export const MARINADE_DEFI_ADDRESS = new PublicKey(
  "89SrbjbuNyqSqAALKBsKBqMSh463eLvzS4iVWCeArBgB"
);

export const MARINADE_DEFI_WRAPPED_SOL_ADDRESS = new PublicKey(
  "AUaXX9HeEEFozEGarKpyp5GU6V7zhYUd7JeCkyc5WrDU"
);

export const MARINADE_DEFI_MSOL_ADDRESS = new PublicKey(
  "Bxq5tzjyHQ2ByZdVxNc37sA6eHp1ANJeZMmE6J2nNoCV"
);

export const MARINADE_NATIVE_STAKING_AUTHORITY = new PublicKey(
  "stWirqFCf2Uts1JBL1Jsd3r6VBWhgnpdPxCTe1MFjrq"
);

export const MARINADE_NATIVE_EXIT_AUTHORITY = new PublicKey(
  "ex9CfkBZZd6Nv9XdnoDmmB45ymbu4arXVk7g5pWnt3N"
);

export const MARINADE_STRATEGY = new PublicKey(
  "MarinadeA1gorithmicDe1egationStrategy111111"
);

export const MARINADE_LOOKUP_TABLE_ADDRESS = new PublicKey(
  "DCcQeBaCiYsEsjjmEsSYPCr9o4n174LKqXNDvQT5wVd8"
);
